export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.207 3.207L6.414 5l5.086 5.086 2.793-2.793.073-.067a1 1 0 011.341.067l4.545 4.544a5.002 5.002 0 011.396 4.358l-.662 3.969a1 1 0 01-.822.822l-3.969.662a5.002 5.002 0 01-4.358-1.396l-4.544-4.545a1 1 0 010-1.414l2.793-2.793L5 6.414 3.207 8.207 1.793 6.793l5-5 1.414 1.414zm1.207 11.792l3.838 3.838a3 3 0 002.614.838l3.265-.544.544-3.265a3 3 0 00-.838-2.614l-3.838-3.838-5.585 5.585z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};